import { render, staticRenderFns } from "./OrderShipments.vue?vue&type=template&id=5a0fd3dc&scoped=true"
import script from "./OrderShipments.vue?vue&type=script&lang=js"
export * from "./OrderShipments.vue?vue&type=script&lang=js"
import style0 from "./OrderShipments.vue?vue&type=style&index=0&id=5a0fd3dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0fd3dc",
  null
  
)

export default component.exports